import { IOnInit } from "angular";
import { GridConfiguration } from "../recordGridView";
import { IQuery } from "../../server/query";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../grids/columns/columnDefinitionService";
import { GridSelectionChangedArgs } from "../../grids/controller";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";

export interface ToggleButtonDefinition {
  id: string;
  text: string;
  checked?: boolean;
  onChanged(
    toggleButton: ToggleButtonDefinition,
    controller: ConfigurableGridFormViewComponentController
  ): void;
}

export interface ToggleButtonCheckChangedHandler {
  (
    toggleButton: ToggleButtonDefinition,
    controller: ConfigurableGridFormViewComponentController
  ): void;
}

export interface ConfigurableGridFormViewControllerHandler {
  (controller: ConfigurableGridFormViewComponentController): void;
}

export interface ConfigurableGridFormViewConfig {
  additionalToggleButtons?: ToggleButtonDefinition[];
  initialized?: ConfigurableGridFormViewControllerHandler;
  gridSelectionChanged?: (
    args: GridSelectionChangedArgs,
    controller: ConfigurableGridFormViewComponentController
  ) => void;
  selectedIds?: number[];
  rowIdSelector?: (row: any) => number;
  gridConfiguration: GridConfiguration;
  navButtonIcon?: string;
  navButtonText?: string;
  showNavButton?: boolean;
  navButtonPermission?: string;
  navPath?: string;
  defaultQuery: IQuery;
  showSelectButtons?: boolean;
}

export class ConfigurableGridFormViewComponentController implements IOnInit {
  /* bindings */
  config!: ConfigurableGridFormViewConfig;
  //gridSelectionChanged!: (args: { args: GridSelectionChangedArgs }) => void;
  /* bindings */

  currentOnly: boolean = true;

  static $inject = [ColumnDefinitionServiceName, UserProfileName];
  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly userProfile: UserProfile
  ) {}

  $onInit(): void {
    if (!this.config.rowIdSelector) {
      this.config.rowIdSelector = (row) => row.Id;
    }
    if (this.config.showSelectButtons) {
      this.config.gridConfiguration.columns = [
        this.columnDefinitionService.getSelectColDef({
          headerName: "select",
        }),
        ...(this.config.gridConfiguration.columns ?? []),
      ];
    }

    this.config.initialized?.(this);
  }

  gridSelectionChanged(args: GridSelectionChangedArgs) {
    this.config.selectedIds = args.gridSelection;
    if (this.config.gridSelectionChanged) {
      this.config.gridSelectionChanged(args, this);
    }
  }

  private shouldShowNavButton(): boolean {
    return (
      (this.config.showNavButton ?? false) &&
      (!this.config.navButtonPermission ||
        this.userProfile.hasPermission(this.config.navButtonPermission))
    );
  }
}
